import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

const RadialIcon = ({ selected }: { selected: boolean }) => {
  return (
    <Grid
      item
      height={`18px`}
      width={`18px`}
      borderRadius={`50px`}
      style={{
        border: `2px solid ${RoutalPalette.primary40}`,
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
      }}
    >
      {selected && (
        <Grid
          item
          height={`12px`}
          width={`12px`}
          borderRadius={`50px`}
          style={{ backgroundColor: RoutalPalette.primary40 }}
        />
      )}
    </Grid>
  );
};

interface SelectPillProps {
  selected?: boolean;
  radialIcon?: boolean;
  radialIconPosition?: `left` | `right`;
  onClick?: () => void;
  containerStyle?: React.CSSProperties;
}
//Text uses label color but body's font size
export const SelectPill = ({
  selected,
  radialIcon = true,
  radialIconPosition = `left`,
  children,
  onClick,
  containerStyle,
}: React.PropsWithChildren<SelectPillProps>) => {
  return (
    <Grid
      item
      style={{
        width: `100%`,
        height: `40px`,
        padding: `16px 12px`,
        border: `1px solid ${RoutalPalette.secondary00}`,
        borderRadius: `5px`,
        display: `flex`,
        flexDirection: `row`,
        alignItems: `center`,
        userSelect: `none`,
        ...containerStyle,
      }}
      onClick={onClick}
    >
      {radialIcon && radialIconPosition === `left` && (
        <div style={{ width: `26px`, display: `flex`, flexDirection: `row`, flexWrap: `nowrap` }}>
          <RadialIcon selected={selected ?? false} />
          <HSpacer small />
        </div>
      )}

      <div style={{ display: `flex`, width: radialIcon ? `calc(100% - 26px)` : `100%` }}>{children}</div>

      {radialIcon && radialIconPosition === `right` && (
        <div style={{ width: `26px`, display: `flex`, flexDirection: `row`, flexWrap: `nowrap` }}>
          <HSpacer small />
          <RadialIcon selected={selected ?? false} />
        </div>
      )}
    </Grid>
  );
};
